export const Emblem = ({ className = "h-10 w-10" }) => (
  <img src="/jolgen-emblem.png" alt="Jolgen Cards" className={`${className} object-contain`} data-testid="jolgen-emblem" />
);
